import type { ReactNode } from 'react'
import type { PlacesType } from 'react-tooltip'
import { hint } from '../../lib/hint.ts'

/** Wraps inline content with a tooltip. For buttons, prefer spreading `hint()` directly. */
export function Hint({
  text,
  place,
  focusable,
  children,
}: {
  text: string
  place?: PlacesType
  /** Info icons with no other control: make them reachable by keyboard (tooltip on focus). */
  focusable?: boolean
  children: ReactNode
}) {
  return (
    <span
      className="inline-flex rounded-seg"
      {...(focusable ? { tabIndex: 0, role: 'note', 'aria-label': text } : {})}
      {...hint(text, place)}
    >
      {children}
    </span>
  )
}
